import React, { useEffect, useMemo, useRef, useState, useCallback } from "react";
import { connect } from "react-redux";
import { InputGroup, InputGroupText, Input, Button, Badge, Spinner, Row, Col } from "reactstrap";
import MessageList from "./MessageList";
import MessageInput from "./MessageInput";
import { listenToMessagesLive, loadOlderMessages, fetchMessagesReset, sendMessage } from "../../redux/Messages/MessagesAction";
import { normEmail } from "../../util/email";
import GroupMembersModal from "./GroupMembersModal";
import { listenToPinnedMessages } from "../../redux/Messages/MessagesAction";
import { getUserDataByEmails } from "../../redux/Messages/UsersPrepTalkAction";

const DEBOUNCE_MS = 150;
const debounce = (fn, ms) => { let t=null; return (...a)=>{ if(t)clearTimeout(t); t=setTimeout(()=>fn(...a),ms);} };



function Messages({ userDetails, thread, presenceItems,
  messagesDesc, loading, error, sending, uploadProgress, hasMoreOlder, loadingOlder,
  startLive, getOlder, reset, doSend, pinnedList, startPinned
}) {

  
  const isAdmin = userDetails?.admin === true;
  const viewMode = thread?.viewMode || "mine";
  const readOnly = isAdmin && viewMode === "others";

  const meEmail = userDetails?.email?.toLowerCase();
  const meName  = userDetails?.name || userDetails?.displayName || meEmail;

  const listRef = useRef(null);
  const wasAtBottomRef = useRef(true);
  const messagesAsc = useMemo(() => (messagesDesc || []).slice().reverse(), [messagesDesc]);

  // const onNewMessage = useCallback((msg) => {
  //   if (!wasAtBottomRef.current && "Notification" in window && Notification.permission === "granted") {
  //     new Notification("New message", { body: (msg.text || "Attachment").slice(0, 80) });
  //     import("../../util/Sound").then(({ ding }) => ding());
  //   }
    
  // }, []);

  // useEffect(() => {
  //   if (!thread?.id) return;
  //   const unsub = startLive({ threadId: thread.id, onNewMessage });
  //   return () => { unsub && unsub(); reset(); };
  // }, [thread?.id, startLive, reset, onNewMessage]);

  // useEffect(() => {
  //   if (!thread?.id) return;
  //   const unsub = startLive({ threadId: thread.id, onNewMessage });
  //   // mark read on open (and again when new messages arrive)
    // import("../../redux/Messages/ThreadsAction").then(({ markThreadRead }) => {
    //   markThreadRead({ threadId: thread.id, meEmail })(()=>{},()=>{});
    // });
  //   return () => { unsub && unsub(); reset(); };
  // }, [thread?.id, startLive, reset, onNewMessage, meEmail]);

  useEffect(() => {
    if (!thread?.id) return;
    const unsub = startLive({ threadId: thread.id });
    // mark read immediately on open
    import("../../redux/Messages/ThreadsAction").then(({ markThreadRead }) => {
      markThreadRead({ threadId: thread.id, meEmail })(()=>{},()=>{});
    });

    import("../../redux/Messages/MessagesAction").then(({ markMessagesRead }) => {
      const latestIds = messagesAsc.slice(-30).map(m => m.id);
      markMessagesRead({ threadId: thread.id, meEmail, messageIds: latestIds })(()=>{},()=>{});
    });
    // clear any title alerts
    import("../../util/TitleAlerts").then(({ clearTitleAlert }) => clearTitleAlert());

    return () => { unsub && unsub(); reset(); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [thread?.id, startLive, reset]);

  // whenever new messages arrive, mark the newest window read and clear title
  // useEffect(() => {
  //   if (!thread?.id || !messagesAsc.length) return;

  //   import("../../redux/Messages/ThreadsAction").then(({ markThreadRead }) => {
  //     markThreadRead({ threadId: thread.id, meEmail })(()=>{},()=>{});
  //   });

  //   import("../../redux/Messages/MessagesAction").then(({ markMessagesRead }) => {
  //     const latestIds = messagesAsc.slice(-30).map(m => m.id);
  //     markMessagesRead({ threadId: thread.id, meEmail, messageIds: latestIds })(()=>{},()=>{});
  //   });
  //   import("../../util/TitleAlerts").then(({ clearTitleAlert }) => clearTitleAlert());
  // }, [messagesAsc, thread?.id, meEmail]);

  useEffect(() => {
    if (!thread?.id) return;
    const unsub = startPinned(thread.id);
    return () => unsub && unsub();
  }, [thread?.id]);


  useEffect(() => {
    if (!thread?.id || !messagesAsc.length) return;
    
    import("../../redux/Messages/MessagesAction").then(({ markMessagesRead }) => {
      const allIds = messagesAsc.map(m => m.id); // ✅ all loaded messages
      markMessagesRead({ threadId: thread.id, meEmail, messageIds: allIds })(()=>{},()=>{});
    });

    import("../../redux/Messages/ThreadsAction").then(({ markThreadRead }) => {
      markThreadRead({ threadId: thread.id, meEmail })(()=>{},()=>{});
    });

    import("../../util/TitleAlerts").then(({ clearTitleAlert }) => clearTitleAlert());
  }, [messagesAsc, thread?.id, meEmail]);



  useEffect(() => {
    const el = listRef.current; if (!el) return;
    if (wasAtBottomRef.current) el.scrollTop = el.scrollHeight;
  }, [messagesAsc]);

  const checkBottom = () => {
    const el = listRef.current; if (!el) return;
    wasAtBottomRef.current = el.scrollHeight - el.scrollTop - el.clientHeight < 60;
  };

  // const onScroll = useMemo(() => debounce(() => {
  //   const el = listRef.current; if (!el) return;
  //   const prevHeight = el.scrollHeight;
  //   if (el.scrollTop < 80 && hasMoreOlder && !loadingOlder) {
  //     getOlder().then(() => {
  //       const delta = el.scrollHeight - prevHeight;
  //       el.scrollTop = el.scrollTop + delta;
  //     });
  //   }
  //   checkBottom();
  // }, DEBOUNCE_MS), [getOlder, hasMoreOlder, loadingOlder]);

  // const onScroll = useMemo(() => debounce(() => { checkBottom(); }, DEBOUNCE_MS), []);
  // const topSentinelRef = useRef(null);

  // useEffect(() => {
  //   const root = listRef.current; if (!root || !topSentinelRef.current) return;
  //   const obs = new IntersectionObserver((entries) => {
  //     entries.forEach(e => {
  //       if (e.isIntersecting && hasMoreOlder && !loadingOlder) {
  //         const prev = root.scrollHeight;
  //         getOlder().then(() => {
  //           const delta = root.scrollHeight - prev;
  //           root.scrollTop = root.scrollTop + delta; // keep visual position
  //         });
  //       }
  //     });
  //   }, { root, rootMargin:"150px 0px 0px 0px", threshold:0 });
  //   obs.observe(topSentinelRef.current);
  //   return () => obs.disconnect();
  // }, [hasMoreOlder, loadingOlder, getOlder]);

  const onScroll = useCallback(async () => {
    const el = listRef.current; if (!el) return;
    if (el.scrollTop <= 48 && hasMoreOlder && !loadingOlder) {
      const prev = el.scrollHeight;
      
      await getOlder();
      const delta = el.scrollHeight - prev;
      el.scrollTop = el.scrollTop + delta; // preserve viewport
    }
    checkBottom();
  }, [hasMoreOlder, loadingOlder, getOlder]);



  // search in conversation
  const [q, setQ] = useState("");
  const qLower = q.toLowerCase();
  // const matches = useMemo(() => {
  //   if (!qLower) return [];
  //   return messagesAsc.map((m, idx) => ({
  //     idx,
  //     hit: (m.text||"").toLowerCase().includes(qLower) ||
  //       (m.attachments||[]).some(a => (a.name||"").toLowerCase().includes(qLower)) ||
  //       (m.links||[]).some(l => (l||"").toLowerCase().includes(qLower))
  //   })).filter(x => x.hit).map(x => x.idx);
  // }, [messagesAsc, qLower]);

  const matches = useMemo(() => {
    if (!qLower) return [];
    return messagesAsc
      .map((m, idx) => ({
        idx,
        hit: m.type !== "system" && (
          (m.text||"").toLowerCase().includes(qLower) ||
          (m.attachments||[]).some(a => (a.name||"").toLowerCase().includes(qLower)) ||
          (m.links||[]).some(l => (l||"").toLowerCase().includes(qLower))
        )
      }))
      .filter(x => x.hit)
      .map(x => x.idx);
  }, [messagesAsc, qLower]);

  const [matchPos, setMatchPos] = useState(0);
  useEffect(() => { setMatchPos(0); }, [qLower]);
  const msgRowRefs = useRef({});
  const setRowRef = (id, el) => { if (el) msgRowRefs.current[id] = el; };
  const jumpTo = async (which) => {
    if (!matches.length) {
      // no matches in current window → try loading older
      await loadUntilMatch(qLower);
      return;
    }

    let pos = matchPos;
    if (which === "next") pos = (matchPos + 1) % matches.length;
    if (which === "prev") pos = (matchPos - 1 + matches.length) % matches.length;

    setMatchPos(pos);
    const idx = matches[pos];
    const msg = messagesAsc[idx];
    const el = msg && msgRowRefs.current[msg.id];
    if (el && listRef.current) el.scrollIntoView({ behavior:"smooth", block:"center" });
  };


  const jumpToMessage = async (id) => {
    // If already loaded, just scroll
    if (msgRowRefs.current[id]) {
      msgRowRefs.current[id].scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    // Otherwise, keep loading older messages until it's found or no more
    while (!msgRowRefs.current[id] && hasMoreOlder && !loadingOlder) {
      const prevHeight = listRef.current?.scrollHeight || 0;
      await getOlder();
      const delta = (listRef.current?.scrollHeight || 0) - prevHeight;
      if (listRef.current) {
        listRef.current.scrollTop += delta; // preserve viewport
      }
    }

    // 🔑 Wait for React to render after getOlder()
    await new Promise((resolve) => setTimeout(resolve, 50));

    // Try scrolling again now that the message should exist
    if (msgRowRefs.current[id]) {
      msgRowRefs.current[id].scrollIntoView({ behavior: "smooth", block: "center" });
    } else {
      console.warn("Message not found after loading:", id);
    }
  };


  const onSend = (text, files) => {
    const parts = thread?.participantsEmails || [];
    doSend({ threadId: thread.id, senderEmail: meEmail, senderName: meName, text, files, participantsEmails: parts });
  };

  const [isMembersOpen, setMembersOpen] = useState(false);

  useEffect(() => {
    if (!thread?.id || !messagesAsc.length) return;
    const lastIds = messagesAsc.slice(-30).map(m=>m.id);

    import("../../redux/Messages/ThreadsAction").then(({ markThreadRead }) => {
      markThreadRead({ threadId: thread.id, meEmail })(()=>{},()=>{});
    });

    import("../../redux/Messages/MessagesAction").then(({ markMessagesRead }) => {
      markMessagesRead({ threadId: thread.id, meEmail, messageIds: lastIds })(()=>{},()=>{});
    });
  }, [messagesAsc, thread?.id, meEmail]);



  // const headerTitle = thread?.isGroup ? (thread?.name || "Group") : (thread?.participantsEmails || []).find(e => e !== normEmail(meEmail));
  const peerEmail = !thread?.isGroup ? (thread?.participantsEmails || []).find(e => e !== normEmail(meEmail)) : null;

  // const pinned = pinnedList;
  
  const messagesRef = useRef(messagesDesc);
  useEffect(() => {
    messagesRef.current = messagesDesc;
  }, [messagesDesc]);

  const [searchingOlder, setSearchingOlder] = useState(false);

  const loadUntilMatch = async (qLower) => {
    setSearchingOlder(true);
    let found = false;

    while (!found && hasMoreOlder && !loadingOlder) {
      // load one more batch
      await getOlder();

      // wait for Redux + React to apply
      await new Promise(res => setTimeout(res, 50));

      // always use latest Redux state from ref
      const updatedMessagesAsc = (messagesRef.current || []).slice().reverse();

      found = updatedMessagesAsc.some(m =>
        (m.text || "").toLowerCase().includes(qLower) ||
        (m.attachments || []).some(a => (a.name || "").toLowerCase().includes(qLower)) ||
        (m.links || []).some(l => (l || "").toLowerCase().includes(qLower))
      );

      if (found) break; // ✅ stop immediately once found
    }

    setSearchingOlder(false);
  };



  useEffect(() => {
    if (!qLower) return; // don’t trigger if empty
    loadUntilMatch(qLower);
  }, [qLower]);


  
  const presenceMap = useMemo(
    () => Object.fromEntries((presenceItems || []).map(p => [p.email, p])),
    [presenceItems]
  );
  const peerOnline = peerEmail ? presenceMap?.[peerEmail]?.online : false;
  

  const [studentData, setStudentData] = useState([]); // { email: displayName }
  
  useEffect(() => {
    let cancelled = false;
    
    async function loadNames() {
      
      const data = await getUserDataByEmails(thread.participantsEmails);
        
      if (!cancelled) setStudentData(data);
    }

    if(!thread?.isGroup) loadNames();
    
    return () => { cancelled = true; };
  }, [thread]);

  const colors = [
    "bg-gradient-blue",
    "bg-gradient-indigo",
    "bg-gradient-purple",
    "bg-gradient-pink",
    "bg-gradient-red",
    "bg-gradient-teal",
    "bg-gradient-cyan",
    "bg-gradient-primary",
    "bg-gradient-info",
    "bg-gradient-danger",
  ];

  function shuffle(array) {
    let arr = [...array];
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }


  const shuffledColors = useMemo(() => shuffle(colors), []);

  return (
    <div className="d-flex flex-column h-100">

      
      {searchingOlder && <div className="text-muted small">Searching older messages…</div>}

      <div className="msgr-chat-header p-2">
        <div className="d-flex align-items-center justify-content-between">
          {/* <div><span className="fw-semibold">{headerTitle}</span>{' '}{thread?.isGroup && <Badge color="info" className="ms-1">Group</Badge>}</div> */}
          <div className="d-flex align-items-center gap-2">
            <div className="position-relative">

              {thread?.isGroup ?
                <div className="msgr-avatar bg-default text-white"><strong>{(thread?.name.slice(0,1).toUpperCase() || "G")}</strong></div>
              :
              <>{ !studentData.find(data => data.email == peerEmail)?.profilePicture ? 
                <div className={"msgr-avatar "+shuffledColors[1]+" text-white"}><span>{(thread?.name || peerEmail ||"?").slice(0,1).toUpperCase()}</span>
                
                </div>
              :
              <img 
                    src={"https://storage.googleapis.com/pre-dental-tracker.appspot.com/profile-picture/" + studentData.find(data => data.email == peerEmail)?.profilePicture}
                    className="msgr-avatar border border-dark" 
                    alt="..." 
                    style={{
                        objectFit:"cover"
                    }}
                /> }</>
                 } 

              {!thread?.isGroup && <span className={`position-absolute bottom-0 end-0 msgr-dot ${/* presence dot */ ''}`} />}
            </div>
            <div className="ml-2">
              <div className="font-weight-bolder text-default">{thread?.isGroup ? (thread?.name || "Group") : (studentData.find(data => data.email == peerEmail)?.name || peerEmail)}</div>
              {/* {!thread?.isGroup && <div className="font-weight-bold text-muted text-xs">{peerEmail}</div>} */}
              {
                thread?.isGroup ? 
                  <Badge color="info" className="ms-1 font-weight-bolder text-capitalize">Group</Badge>
                : <Badge color={peerOnline? "success" : "light"} className="ms-1 font-weight-bolder text-capitalize">{peerOnline ? "Online" : "Offline"}</Badge>  
              }

           

              

            </div>
          </div>

          <div className="d-flex align-items-center justify-content-end">
            
            <div>
              {thread?.isGroup && <Button size="sm" color="warning" onClick={()=>setMembersOpen(true)}><i class="fas py-1 text-lg fa-cog"></i></Button>}
              {/* {loading && <Spinner size="sm" className="ms-2" />} */}
            </div>
          </div>
          {thread?.isGroup &&
          <GroupMembersModal key={thread.id} readOnly={readOnly} isOpen={isMembersOpen} toggle={()=>setMembersOpen(false)} thread={thread} />}

          
          {/* <div>{loading && <Spinner size="sm" />}</div> */}
        </div>
        <div className="mt-2">
          <InputGroup>
            <InputGroupText><i class="fas fa-search text-primary font-weight-bolder text-lg"></i></InputGroupText>
            <Input className="pl-2" placeholder="Search in conversation…" value={q} onChange={e=>setQ(e.target.value)} />
            <InputGroupText>{matches.length ? `${matchPos+1}/${matches.length}` : "0/0"}</InputGroupText>
            <Button color="primary" className="ml-2" onClick={()=>jumpTo("prev")} disabled={!matches.length}><i class="fas fa-arrow-left"></i></Button>
            <Button color="primary" onClick={()=>jumpTo("next")} disabled={!matches.length}><i class="fas fa-arrow-right"></i></Button>
          </InputGroup>
          {error && <div className="text-danger small mt-2">{error}</div>}
        </div>
      </div>

      {/* <div ref={listRef} onScroll={onScroll} className="msgr-bubbles overflow-auto" style={{height:'100%'}}>
        {hasMoreOlder && <div className="text-center text-muted small mb-2">{loadingOlder ? "Loading older…" : "Scroll up to load older"}</div>}
        <MessageList messages={messagesAsc} currentUserEmail={meEmail} searchQuery={qLower} setRowRef={setRowRef} />
      </div> */}
      {pinnedList.length > 0 && (
        <Row className="overflow-auto w-100 ml-0 border-bottom border-lighter border" style={{ minHeight:"80px", maxHeight: "100px" }}>
          {pinnedList.map(m => (
            <Col 
              lg="12"
              key={m.id}
              className="py-2 d-flex border-bottom border-lighter pin-list-item" style={{height:"80px"}}
              onClick={() => jumpToMessage(m.id)}
            >
              <span className="d-flex align-items-center"><i class="fas fa-thumbtack text-purple"></i></span><span className="ml-3 text-sm font-weight-bolder d-flex align-items-center">{m.text?.slice(0,70) + "..." || m.attachments?.[0]?.name || "Pinned"}</span>
            </Col>
          ))}
        </Row>
      )}


      <div ref={listRef} onScroll={onScroll} className="msgr-bubbles overflow-auto" style={{height:'100%'}}>
        {/* <div ref={topSentinelRef} style={{ height: 1 }} /> */}
        <MessageList messages={messagesAsc} studentData={studentData} currentUserEmail={meEmail} searchQuery={qLower} setRowRef={setRowRef} uploadProgress={uploadProgress} readOnly={readOnly}/>
      </div>

        {/* {pinned.length > 0 && (
        <div className="msgr-active-strip">
          {pinned.slice(-10).map(m => (
            <span key={m.id}
              className="msgr-active-chip"
              onClick={() => { msgRowRefs.current[m.id]?.scrollIntoView({ behavior:"smooth", block:"center" }); }}>
              📌 {m.text?.slice(0,30) || m.attachments?.[0]?.name || "Pinned"}
            </span>
          ))}
        </div>
      )} */}
      
      


      {/* <div className="msgr-composer"><MessageInput threadId={thread.id} meEmail={meEmail} onSend={onSend} sending={sending} uploadProgress={uploadProgress} /> */}

      {readOnly ? (
          <div className="text-center text-muted py-3 border-top bg-lighter text-sm font-weight-500">
            <i className="fas fa-eye"></i> View-only mode (Admin - Other Thread)
          </div>
        ) : (
          <div className="msgr-composer">
            <MessageInput
              threadId={thread.id}
              meEmail={meEmail}
              onSend={onSend}
              sending={sending}
              uploadProgress={uploadProgress}
            />
          </div>
        )}


{/* </div> */}
    </div>
  );
}

export default connect(
  s => ({
    userDetails: s.loginAuth.userDetails,
    messagesDesc: s.messages.messagesDesc,
    loading: s.messages.loading, error: s.messages.error,
    sending: s.messages.sending, 
    uploadProgress: s.messages.uploadProgress,
    hasMoreOlder: s.messages.hasMoreOlder, loadingOlder: s.messages.loadingOlder,
    pinnedList: s.messages.pinnedList,
    presenceItems: s.presence.items
  }),
  d => ({
    startLive: (args)=>d(listenToMessagesLive(args)),
    getOlder: ()=>d(loadOlderMessages()),
    reset: ()=>d(fetchMessagesReset()),
    doSend: (args)=>d(sendMessage(args)),
    startPinned: (threadId)=>d(listenToPinnedMessages(threadId))
}))(Messages);
